export default __webpack_public_path__ + "static/media/customerLoyaltyy.73567cca.jpg";